// extracted by mini-css-extract-plugin
module.exports =  {"alert":"CQMmIbqaltE0JVCg8i41","spinner":"fEqPuJAuu2qiSj8t5EUH"};